import { InfoGraphic } from '../info-graphic'

function PrioSmsInfoGraphic() {
  return (
    <InfoGraphic>
      <p>When "Text or Email" is selected, text message is prioritized.</p>
    </InfoGraphic>
  )
}

export { PrioSmsInfoGraphic }
